type DollarSignIconProps = React.SVGProps<SVGSVGElement>;

const DollarSignIcon: React.FC<DollarSignIconProps> = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    width={20}
    height={20}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 6C8.343 6 7 6.895 7 8C7 9.105 8.343 10 10 10C11.657 10 13 10.895 13 12C13 13.105 11.657 14 10 14M10 6V14M10 6C11.11 6 12.08 6.402 12.599 7M10 6V5M10 14V15M10 14C8.89 14 7.92 13.598 7.401 13M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export default DollarSignIcon;
